import React from 'react'

const Contact = () => {
  return (
    <div>This page is under construction. Don't worry when i get employed i will complete it.<br/>
      You can contact me on twitter <a href='https://twitter.com/AkeemAhmid?s=09' target='_blank'>@AkeemAhmid</a> or Whatsapp <a href='https://wa.me/qr/KWSO5Q47V7PZD1' target='_blank'>08021156433</a>  <br/>
      Enjoy the website and send your thought to me via any social media Account 
      </div>
  )
}

export default Contact